import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useImpactsOnStakeholdersForm } from '@Router/ImpactsOnStakeholdersManagement/Containers/ImpactsOnStakeholdersFormProvider';
import { useWatch } from 'react-hook-form';
import {
  StakeholderAnalysisFormValues,
  StakeholderGroupFormValues,
} from '../../../ImpactsOnStakeholdersFormProvider/types';
import { sortStakeholderGroups } from '../../utils';

interface ActionDeleteStakeholderAnalysisProps {
  rowId: string;
}

const ActionDeleteStakeholderAnalysis = ({
  rowId,
}: ActionDeleteStakeholderAnalysisProps) => {
  const { getValues, setValue, trigger } = useImpactsOnStakeholdersForm();
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();

  const { completedSection } = useWatch({
    name: 'stakeholderAnalysis',
  }) as StakeholderAnalysisFormValues;

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const index = Number(rowId.replace(/^(DETAILS_|NEW_)/, ''));

  const handleDelete = () => {
    const currentStakeholders =
      getValues('stakeholderAnalysis.stakeholderGroups') || [];

    const sortedGroups = sortStakeholderGroups(currentStakeholders);

    const updatedStakeholders = rowId.startsWith('DETAILS_')
      ? currentStakeholders.filter(
          (stakeholder: StakeholderGroupFormValues) => stakeholder.id !== index
        )
      : sortedGroups.filter((_, i) => i !== index - 1);

    setValue('stakeholderAnalysis.stakeholderGroups', updatedStakeholders);
    trigger('stakeholderAnalysis.stakeholderGroups');

    closeModal();
  };

  return (
    <>
      <GridActionsCellItem
        icon={<DeleteOutlinedIcon fontSize="small" />}
        label="Delete"
        disabled={isCompletedTh || isCompletedEn}
        onClick={openModal}
      />

      <DeleteModal
        opened={isModalOpen}
        close={closeModal}
        confirm={handleDelete}
        topic="รายละเอียดการวิเคราะห์ผู้มีส่วนได้เสียในห่วงโซ่คุณค่าธุรกิจ"
      />
    </>
  );
};

export default ActionDeleteStakeholderAnalysis;
